import comp from "./ResourceList";
import withLoader from "UIComponents/GqlWithLoader";
export default withLoader(comp);
